export default __webpack_public_path__ + "static/DoneByHumans-fd3e902722fcef1c61be6d038474ab33.png";